module.exports = __webpack_public_path__ + "media/images/order-again-df724eec448a6e5050079966f6063693.svg";